import $ from "jquery"
import "jquery-autocomplete"
import "jquery-autocomplete/jquery.auto-complete.css"

import React from 'react'
import ReactDOM from "react-dom";

import "../scss/index.scss"

import SearchStatefulComponent from './components/SearchStatefulComponent'


function runQueryTable(elem) {
    const $elem = $(elem);
    ReactDOM.render(
        <SearchStatefulComponent
            search_url={$elem.data("search-url")}
            widget_types={$elem.data("widget-types")}
            autocomplete={$elem.data("autocomplete")}
            hide_search={$elem.data("hide-search")}
        />,
        $elem.find(".query-container")[0]
    );
}


$(function() {

    $(".expert-search").each(function(i, elem) {
        runQueryTable(elem);
    });

});



// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/index.js